import { call, select, takeLeading } from 'redux-saga/effects';

import * as $auth from 'modules/auth';
import * as api from '../api';
import * as actions from '../actions';

const createDefaultArtset = function* () {
  const user = yield select($auth.getCurrentUser);
  const token = yield select($auth.getToken);
  const publisherId = yield select($auth.getSelectedPublisherId);

  yield call(api.createArtset, { artistName: user.name }, { token, publisherId });
};

export const createArtsetSaga = function* () {
  yield takeLeading(actions.createDefaultArtset, createDefaultArtset);
};
